export function contentTitle(displayNo: number | null | undefined,
  legacyNo: string | null | undefined, title: string): string {
  const no = displayNo ?? legacyNo;
  return no ? `${no} · ${title}` : title;
}
